/* WorkTriggerTargetsTabRenderer.js */

"use strict";
const _ = require("lodash");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const AdvancedFilter = require("@gluenetworks/entity_grid_gl").AdvancedFilter;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const LABELS_FOR_CONVERT = {
    TO_STATIC: "Convert to static target list",
    TO_DYNAMIC: "Convert to dynamic target list",
};

class WorkTriggerTargetsTabRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("worktrig-targets-view-tab-gl");
        this._rootElem.component = this._model;
        this._targets = {};

        const gameEditorElem =
            this._model.workTriggerDetailsView._renderer._rootElem.parentNode.parentNode;
        this._editorViewLeftActionElem = gameEditorElem.querySelector(
            "game-editor-view-actions-gl left-container"
        );

        this._convertButton = new ButtonControl({label: "<span></span>"});

        if (this._model._method === "query") {
            this._convertButton.setLabel(LABELS_FOR_CONVERT.TO_STATIC);
        } else {
            this._convertButton.setLabel(LABELS_FOR_CONVERT.TO_DYNAMIC);
        }

        if (this._model._workTriggerDetailsView._converted === true) {
            this._convertButton.setDisabled(true);
        }

        if (
            _.get(
                this._model._workTriggerDetailsView._triggerType.getWorkTarget(),
                "category",
                ""
            ) === "construct"
        ) {
            this._convertButton.setDisabled(true);
        }

        this._addButtonIcon = document.createElement("base-icon-gl");
        this._addButtonIcon.setAttribute("class", "btn-icon-right");
        this._addButtonIcon.dataset.icon = "common.back";

        this._removeButtonIcon = document.createElement("base-icon-gl");
        this._removeButtonIcon.setAttribute("class", "btn-icon-left");
        this._removeButtonIcon.dataset.icon = "common.back";

        this._removeAllButtonIcon = document.createElement("base-icon-gl");
        this._removeAllButtonIcon.setAttribute("class", "btn-icon-left");
        this._removeAllButtonIcon.dataset.icon = "common.back";

        this._addButton = new ButtonControl({label: "<span>Add</span>"});
        this._addButton._renderer._rootElem.appendChild(this._addButtonIcon);

        this._removeButton = new ButtonControl({label: "<span>Remove</span>"});
        this._removeButton._renderer._rootElem.prepend(this._removeButtonIcon);

        this._removeAllButton = new ButtonControl({label: "<span>Remove All</span>"});
        this._removeAllButton._renderer._rootElem.prepend(this._removeAllButtonIcon);
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on(
            "PagingFeedChange",
            (this._onPagingFeedChange = this._onPagingFeedChange.bind(this))
        );
        this._addButton.on(
            "UserClick",
            (this._onAddButtonClick = this._onAddButtonClick.bind(this))
        );
        this._removeButton.on(
            "UserClick",
            (this._onRemoveButtonClick = this._onRemoveButtonClick.bind(this))
        );
        this._removeAllButton.on(
            "UserClick",
            (this._onRemoveAllButtonClick = this._onRemoveAllButtonClick.bind(this))
        );
        this._convertButton.on(
            "UserClick",
            (this._onConvertButtonClick = this._onConvertButtonClick.bind(this))
        );
        this._model.on(
            "BackFromTarget",
            (this._backButtonClicked = this._backButtonClicked.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("PagingFeedChange", this._onPagingFeedChange);
        this._addButton.removeListener("UserClick", this._onAddButtonClick);
        this._removeButton.removeListener("UserClick", this._onRemoveButtonClick);
        this._removeAllButton.removeListener("UserClick", this._onRemoveAllButtonClick);
        this._convertButton.removeListener("UserClick", this._onConvertButtonClick);
        this._model.removeListener("BackFromTarget", this._backButtonClicked);
    }

    _registerAvailGridListeners() {
        this._availableTargetsGrid.on(
            "UserSelectedRows",
            (this._onAvailGridUserSelectedRows = this._onAvailGridUserSelectedRows.bind(this))
        );
        this._availableTargetsGrid.on(
            "UserRowDoubleClicked",
            (this._onAvailGridUserRowDoubleClicked =
                this._onAvailGridUserRowDoubleClicked.bind(this))
        );
    }

    _unregisterAvailGridListeners() {
        if (this._availableTargetsGrid) {
            this._availableTargetsGrid.removeListener(
                "UserSelectedRows",
                this._onAvailGridUserSelectedRows
            );
            this._availableTargetsGrid.removeListener(
                "UserRowDoubleClicked",
                this._onAvailGridUserRowDoubleClicked
            );
        }
    }

    _registerSelGridListeners() {
        this._selectedTargetsGrid.on(
            "UserSelectedRows",
            (this._onSelGridUserSelectedRows = this._onSelGridUserSelectedRows.bind(this))
        );
        this._selectedTargetsGrid.on(
            "UserRowDoubleClicked",
            (this._onSelGridUserRowDoubleClicked = this._onSelGridUserRowDoubleClicked.bind(this))
        );
    }

    _unregisterSelGridListeners() {
        this._selectedTargetsGrid.removeListener(
            "UserSelectedRows",
            this._onSelGridUserSelectedRows
        );
        this._selectedTargetsGrid.removeListener(
            "UserRowDoubleClicked",
            this._onSelGridUserRowDoubleClicked
        );
    }

    _registerAdvancedFilterListeners() {
        this._advancedFilter.on(
            "AdvancedFilterRuleChanged",
            (this._onAdvFilterRuleChange = _.debounce(this._onAdvFilterRuleChange.bind(this), 500))
        );
    }

    _unregisterAdvancedFilterListeners() {
        this._advancedFilter.removeListener(
            "AdvancedFilterRuleChanged",
            this._onAdvFilterRuleChange
        );
    }

    _onAdvFilterRuleChange(e) {
        try {
            const workTarget = this._model._workTriggerDetailsView._triggerType.getWorkTarget(),
                currentQuery = e.builder.getMongo();

            if (currentQuery) {
                _.set(workTarget, "query", currentQuery);
                this._model._workTriggerDetailsView._triggerType.setWorkTarget(workTarget);

                let noticeElem =
                    this._model._workTriggerDetailsView._renderer._tabComponents.general._renderer._targetsCountControl.parentElement.querySelector(
                        "notice"
                    );

                const targetCount =
                    this._model._workTriggerDetailsView._renderer._tabComponents.general._renderer
                        ._targetsCountControl;

                if (!noticeElem) {
                    noticeElem = document.createElement("notice");
                    noticeElem.classList.add("inline-control-gl");
                    noticeElem.innerText = "Dynamic Filter in use";
                    targetCount.parentElement.appendChild(noticeElem);
                }

                this._model._selectedDevicesPagingFeed.setFilter(currentQuery);

                _.delay(() => {
                    const count = this._model._selectedDevicesPagingFeed._entityOrder.length;
                    targetCount.innerText = count;
                }, 1000);
            }
        } catch (e) {
            this._model._selectedDevicesPagingFeed.setFilter({});
            _.set(
                this._model._workTriggerDetailsView,
                "_renderer._tabComponents.general._renderer._targetsCountControl.innerText",
                " All"
            );
            const noticeElement =
                this._model._workTriggerDetailsView._renderer._tabComponents.general._renderer._targetsCountControl.parentElement.querySelector(
                    "notice"
                );
            if (noticeElement) {
                noticeElement.remove();
            }
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    async _renderAdvancedFilter() {
        if (this._model._method === "query") {
            await this._model.retrieveCustomFieldsEntity();
            const customFieldsList = [];
            for (let field in this._model._customFieldsWithInherited) {
                if (
                    this._model._customFieldsWithInherited.hasOwnProperty(field) &&
                    !this._model._customFieldsWithInherited[field].systemOwned &&
                    ["Boolean", "String", "Enum", "Dropdown", "Number"].indexOf(
                        this._model._customFieldsWithInherited[field].dataType
                    ) >= 0
                ) {
                    customFieldsList.push(
                        Object.assign({}, this._model._customFieldsWithInherited[field], {
                            id: field,
                            name: `customFieldValues.${field}`,
                            label: this._model._customFieldsWithInherited[field].name,
                        })
                    );
                }
            }

            let enabledNodeProps = Object.entries(this._model._nodeProps).map(([id, props]) => {
                id = id.replace(/[\t\n\r ]+/g, " ");
                let prop = Object.assign(props);
                prop = Object.assign(prop, {
                    id: `nodeProps.${id}`,
                    name: `nodeProps.${id}`,
                    label: id,
                    path: `nodeProps.${id}`,
                    dataType: props.type || "string",
                });
                if (props.type === "enum") {
                    prop.options = {};
                    props.values.forEach((val) =>
                        Object.assign(prop.options, {[val]: {name: val, title: val}})
                    );
                }
                return {[`nodeProps.${id}`]: prop};
            });

            _.assign(this._model.columnConfigFilter, ...enabledNodeProps);

            this._filterContainer = document.createElement("filter-container");
            this._advancedFilter = new AdvancedFilter({
                filterData: this._model._filter,
                columnsConfig: this._getFilterOptions(
                    this._model.columnConfigFilter,
                    customFieldsList
                ),
                allowGroups: true,
            });

            this._registerAdvancedFilterListeners();
            this._filterContainer.appendChild(this._advancedFilter._renderer._rootElem);
            this._mainContainer.appendChild(this._filterContainer);
        }
    }
    render() {
        this._model._workTriggerDetailsView._renderer._hideViewActions();
        if (this._rootElem.hasChildNodes()) {
            this._model.gameEditor._titleCmpnt.setTitle("Targets");
            this._model.gameEditor.showViewAction("BackToDetails");
            this._renderBackButton();

            return Promise.resolve();
        }

        if (!this._mainContainer) {
            this._mainContainer = document.createElement("main-container");
            this._rootElem.appendChild(this._mainContainer);
        }

        return this._renderBackButton()
            .then(() => {
                this._model.whenFeedReady();
            })
            .then(() => {
                this._model._method !== "query"
                    ? this._renderAvailGrid()
                    : this._renderAdvancedFilter();
            })
            .then(() => {
                this._model._method !== "query" ? this._renderSelControls() : Promise.resolve();
            })
            .then(() => {
                this._renderSelGrid().then(() => {
                    this._registerListeners();
                    this._editorViewLeftActionElem.appendChild(
                        this._convertButton._renderer._rootElem
                    );
                    this._model.gameEditor._titleCmpnt.setTitle("Targets");
                    this._model.gameEditor.showViewAction("BackToDetails");
                    if (this._model._method !== "query") {
                        let ids = this._model._getWorkTargetIds();
                        _.delay(this._initTargets.bind(this), 500, ids);
                    }
                    return Promise.resolve();
                });
            })
            .catch((err) => {
                console.error(err);
            });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }

    get selectedRows() {
        return this._availableTargetsGrid.getSelectedRows();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    _renderBackButton() {
        const model = this._model;

        const bcs = [
            {
                content: backButton,
                left: {
                    arrow: {
                        direction: "left",
                    },
                },
            },
        ];
        this._model.gameEditor.setBreadCrumbs(bcs);

        return Promise.resolve();

        function backButton() {
            const el = document.createElement("span");
            el.innerHTML = "Details";
            el.addEventListener("click", () => {
                // clear breadcrumbs link
                model._workTriggerDetailsView._targetViewOpen = undefined;
                if (model._workTriggerDetailsView._triggerType.isDirty()) {
                    model._workTriggerDetailsView._renderer._showViewActions();
                } else {
                    model._workTriggerDetailsView._renderer._hideViewActions();
                }
                model._gameEditor._titleCmpnt.setTitle("Details");
                model.gameEditor.hideViewAction("BackToDetails");
                model.gameEditor.setBreadCrumbs([]);
                // change tab back to general
                model.workTriggerDetailsView.setEditorMode("general");

                model.shutdown();
            });
            // prettier-ignore
            this.renderer = { //jshint ignore:line
                rootElement: el
            };
        }
    }

    _renderSelControls() {
        this._selControlContainer = document.createElement("sel-control-container");
        this._mainContainer.appendChild(this._selControlContainer);

        return Promise.resolve().then(() => {
            this._selControlContainer.appendChild(this._addButton.renderer.rootElement);
            this._selControlContainer.appendChild(this._removeButton.renderer.rootElement);
            this._selControlContainer.appendChild(this._removeAllButton.renderer.rootElement);
            this._addButton.renderer.rootElement.classList.add("target-button");
            this._removeButton.renderer.rootElement.classList.add("target-button");
            this._removeAllButton.renderer.rootElement.classList.add("target-button");
        });
    }

    _renderSelGrid() {
        this._removeButton.disabled = true;
        this._removeAllButton.disabled = true;
        if (this._selGridContainer) {
            this._selGridContainer.remove();
            this._selGridContainer = undefined;
        }

        if (!this._selGridContainer) {
            this._selGridContainer = document.createElement("sel-grid-container");
            this._mainContainer.appendChild(this._selGridContainer);

            this._selGridTitle = document.createElement("div");
            this._selGridTitle.classList.add("title-section");

            this._selGridContainer.appendChild(this._selGridTitle);
            if (this._model._method === "query") {
                this._selGridTitle.innerHTML = "Filtered Devices";
            } else {
                this._selGridTitle.innerHTML = "Selected Devices";
            }
        }
        if (this._selectedTargetsGrid) {
            this._unregisterSelGridListeners();

            this._selectedTargetsGrid.shutdown();
        }
        this._selectedTargetsGrid = new EntityGrid({
            singleSelect: false,
            columns: this._model.selColumnConfig,
            pagingFeed: this._model.selectedTargetsPagingFeed,
            showHeader: true,
            gridKey: `${this._model._gridKey}_selected`,
            showLinesNumber: true,
            useUserDataStorage: false,
        });
        this._selGridContainer.appendChild(this._selectedTargetsGrid.renderer.rootElement);
        this._registerSelGridListeners();

        return Promise.resolve();
    }

    _renderAvailGrid() {
        this._addButton.disabled = true;
        if (this._availGridContainer) {
            this._availGridContainer.remove();
            this._availGridContainer = undefined;
        }
        if (!this._availGridContainer) {
            this._availGridContainer = document.createElement("avail-grid-container");
            this._mainContainer.appendChild(this._availGridContainer);

            this._availGridTitle = document.createElement("div");
            this._availGridTitle.classList.add("title-section");

            this._availGridContainer.appendChild(this._availGridTitle);
            this._availGridTitle.innerHTML = "Available Devices";
        }
        if (this._availableTargetsGrid) {
            this._unregisterAvailGridListeners();
            this._availGridContainer.removeChild(this._availableTargetsGrid.renderer.rootElement);
            this._availableTargetsGrid.shutdown();
        }
        this._availableTargetsGrid = new EntityGrid({
            singleSelect: false,
            columns: this._model.availColumnConfig,
            pagingFeed: this._model.availableTargetsPagingFeed,
            showHeader: true,
            gridKey: `${this._model._gridKey}_available`,
            showLinesNumber: true,
            useUserDataStorage: false,
        });
        this._availGridContainer.appendChild(this._availableTargetsGrid.renderer.rootElement);
        this._registerAvailGridListeners();
    }

    _getFilterOptions(columnsData, customFields) {
        columnsData = Object.keys(columnsData).map((i) =>
            Object.assign({}, columnsData[i], {id: i, field: i, name: i})
        );
        columnsData = this._getFilterFieldsConfig(Object.values(columnsData));
        const filterOptions = [].concat(Object.values(columnsData), customFields);
        const allowedCustomFieldTypes = ["boolean", "string", "enum", "number", "pathlist"];
        return filterOptions
            .filter((option) => {
                if (
                    option.dataType &&
                    !allowedCustomFieldTypes.includes(option.dataType.toLowerCase())
                ) {
                    return false;
                }
                return true;
            })
            .map((optData) => {
                const options = {
                    dataType: optData.dataType ? optData.dataType.toLowerCase() : undefined,
                };
                return Object.assign({}, optData, options);
            });
    }

    _getFilterFieldsConfig(columnsConfig) {
        const getDataType = (dataType) => {
            const allowedTypes = [
                "string",
                "integer",
                "double",
                "date",
                "time",
                "datetime",
                "boolean",
                "pathlist",
            ];
            if (allowedTypes.includes(dataType)) {
                return dataType;
            }
            switch (dataType) {
                case "number":
                    return "integer";
                default:
                    return "string";
            }
        };

        const generateFilterItem = ({name, label, dataType, options, validation, typeInfo}) => {
            let normalisedDataType = getDataType(dataType);

            const filterItem = {
                id: name,
                field: name,
                name: name,
                dataType: dataType,
                label: label,
                type: normalisedDataType,
                size: 35,
            };

            if (dataType === "enum" && typeInfo && !typeInfo.multiSelect) {
                const {ids = [], labels = []} = typeInfo;
                options = labels.map((label, idx) => ({[ids[idx]]: label}));
            }

            if (!_.isEmpty(validation)) {
                Object.assign(filterItem, {validation: validation});
            }

            if (!_.isEmpty(options) && dataType !== "pathlist") {
                Object.assign(filterItem, {
                    typeInfo: {
                        ids: Object.keys(options).map((i) => options[i].name),
                        labels: Object.keys(options).map((i) => options[i].title),
                        multiSelect: false,
                    },
                    input: "select",
                    operators: ["equal_select", "not_equal_select", "is_empty", "is_not_empty"],
                });
            }
            if (dataType === "longstring") {
                Object.assign(filterItem, {
                    values: options,
                    input: "text",
                    operators: [
                        "longstring_begins_with",
                        "longstring_not_begins_with",
                        "contains",
                        "not_contains",
                        "longstring_ends_with",
                        "longstring_not_ends_with",
                        "is_empty",
                        "is_not_empty",
                    ],
                });
            }

            if (dataType === "boolean") {
                Object.assign(filterItem, {
                    operators: ["equal", "is_empty", "is_not_empty"],
                    input: "radio",
                    default_value: true,
                    values: {
                        1: "Yes",
                        0: "No",
                    },
                    valueSetter: function (rule, value) {
                        value = Number(value) || 0;
                        const name = rule.id + "_value_0";
                        rule.$el
                            .find("[name=" + name + '][value="' + value + '"]')
                            .prop("checked", true)
                            .trigger("change");
                    },
                });
            }

            if (dataType === "date") {
                Object.assign(
                    filterItem,
                    {
                        operators: [
                            "equal",
                            "less",
                            "less_or_equal",
                            "greater",
                            "greater_or_equal",
                            "is_empty",
                            "is_not_empty",
                        ],
                    },
                    this.generateCalendarInput(name)
                );
            }

            if (dataType === "pathlist") {
                Object.assign(filterItem, {
                    options,
                    input: "select",
                    operators: ["pathlist_equals", "pathlist_not_equals"],
                });
            }

            return filterItem;
        };
        return columnsConfig.map(generateFilterItem);
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onPagingFeedChange() {
        this._renderAvailGrid();
        this._renderSelGrid();
    }

    _onAvailGridUserSelectedRows(e) {
        this._addButton.disabled = this._checkDisabled(e.selectedRows.length === 0);
    }

    _onAvailGridUserRowDoubleClicked(e) {
        if (!this._checkDisabled(false)) {
            this._addToTargets([e.selectedRow]);
        }
    }

    _backButtonClicked(model) {
        model._gameEditor._titleCmpnt.setTitle("Details");
        model.gameEditor.hideViewAction("BackToDetails");
        model.shutdown();
    }

    _onAddButtonClick() {
        if (!_.isEmpty(this._availableTargetsGrid.getSelectedRows())) {
            this._addToTargets(this._availableTargetsGrid.getSelectedRows());
        }
    }

    _onSelGridUserSelectedRows(e) {
        this._removeButton.disabled = this._checkDisabled(e.selectedRows.length === 0);
    }

    _onSelGridUserRowDoubleClicked(e) {
        if (!this._checkDisabled(false)) {
            this._removeFromTargets([e.selectedRow]);
        }
    }

    _onRemoveButtonClick() {
        this._removeFromTargets(this._selectedTargetsGrid.getSelectedRows());
    }

    _onRemoveAllButtonClick() {
        const allEntities = this._selectedTargetsGrid.getEntities(),
            ids = Object.keys(allEntities);
        let idsToRemove = [],
            isConstruct = false;

        if (
            _.get(
                this._model._workTriggerDetailsView._triggerType.getWorkTarget(),
                "category",
                ""
            ) === "construct"
        ) {
            isConstruct = true;
            Object.values(allEntities).forEach((entity) => {
                idsToRemove.push(entity.getNodeId());
            });
        }
        this._model.availableTargetsPagingFeed.removeAllIds();
        if (isConstruct) {
            this._model.selectedTargetsPagingFeed.removeAllIds(true);
        } else {
            this._model.selectedTargetsPagingFeed.removeAllIds();
        }
        this._availableTargetsGrid.setSelectedRows(ids);
        this._addButton.disabled = this._checkDisabled(false);
        this._removeButton.disabled = true;
        this._removeAllButton.disabled = true;
        this._removeIdsFromModel(!isConstruct ? ids : idsToRemove);
    }

    _onConvertButtonClick() {
        if (this._model._method === "query") {
            this._changeFromQueryToList();
        } else {
            this._changeFromListToQuery();
        }
    }

    async _changeFromQueryToList() {
        try {
            await this._model._workTriggerDetailsView._modalUserFeedback.displayConfirmation(
                `Are you sure you want to convert the current dynamic target list based on a filter into a static target list?\n`,
                {
                    title: "Convert into Static Target List",
                    confirmDetails: {
                        text: "Confirm",
                        type: "destructive",
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text",
                    },
                }
            );
            _.delay(this._toList.bind(this), 500);
        } catch (e) {
            console.log("User reject");
        }
    }

    async _changeFromListToQuery() {
        try {
            await this._model._workTriggerDetailsView._modalUserFeedback.displayConfirmation(
                `Are you sure you want to replace the current static target list with an empty dynamic target list?\n`,
                {
                    title: "Replace with Dynamic Target List",
                    confirmDetails: {
                        text: "Confirm",
                        type: "destructive",
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text",
                    },
                }
            );
            _.delay(this._toQuery.bind(this), 500);
        } catch (e) {
            console.log("User reject");
        }
    }

    async _toList() {
        this._model._workTriggerDetailsView._modalUserFeedback.displayLoading();
        this._model._method = "multi";
        const workTarget = this._model._workTriggerDetailsView._triggerType.getWorkTarget();
        let devices = [];

        devices = await this._model._selectedDevicesPagingFeed.fetchAllEntityIds();

        _.set(workTarget, "method", "multi");
        _.set(workTarget, "ids", devices);
        delete workTarget.query;
        this._model._workTriggerDetailsView._triggerType.setWorkTarget(workTarget);

        await this._model._selectedDevicesPagingFeed.shutdown();
        this._model._selectedDevicesPagingFeed = undefined;

        const noticeElement =
            this._model._workTriggerDetailsView._renderer._tabComponents.general._renderer._targetsCountControl.parentElement.querySelector(
                "notice"
            );
        if (noticeElement) {
            noticeElement.remove();
        }

        this._rootElem.innerHTML = "";
        this._mainContainer.remove();
        this._mainContainer = undefined;
        this._model._initiateFeeds();
        await this.render();
        this._model._workTriggerDetailsView._converted = true;
        this._convertButton.setDisabled(true);
        this._convertButton.setLabel(LABELS_FOR_CONVERT.TO_DYNAMIC);
        this._model._workTriggerDetailsView._modalUserFeedback.hideDisplayed();
    }

    async _toQuery() {
        this._model._workTriggerDetailsView._modalUserFeedback.displayLoading();
        this._model._method = "query";
        const workTarget = this._model._workTriggerDetailsView._triggerType.getWorkTarget();

        _.set(workTarget, "method", "query");
        _.set(workTarget, "query", {});
        delete workTarget.ids;
        this._model._workTriggerDetailsView._triggerType.setWorkTarget(workTarget);

        _.set(
            this._model._workTriggerDetailsView,
            "_renderer._tabComponents.general._renderer._targetsCountControl.innerText",
            " All"
        );

        this._rootElem.innerHTML = "";
        this._mainContainer.remove();
        this._mainContainer = undefined;

        await this._model._selectedDevicesPagingFeed.shutdown();
        this._model._selectedDevicesPagingFeed = undefined;

        this._model._initiateFeeds();
        await this.render();
        this._model._workTriggerDetailsView._converted = true;
        this._convertButton.setDisabled(true);
        this._convertButton.setLabel(LABELS_FOR_CONVERT.TO_STATIC);
        this._model._workTriggerDetailsView._modalUserFeedback.hideDisplayed();
    }

    _onShutdown() {
        let shutdowns = [
            this._availableTargetsGrid ? this._availableTargetsGrid.shutdown() : Promise.resolve(),
            this._addButton.shutdown(),
            this._removeButton.shutdown(),
            this._removeAllButton.shutdown(),
            this._selectedTargetsGrid.shutdown(),
            this._convertButton.shutdown(),
        ];
        return Promise.all(shutdowns)
            .then(() => {
                this._unregisterListeners();
                this._unregisterAvailGridListeners();
                this._unregisterSelGridListeners();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                if (this._availGridContainer) {
                    this._availGridContainer.remove();
                }
                this._availGridContainer = undefined;
                if (this._selControlContainer) {
                    this._selControlContainer.remove();
                }
                this._selControlContainer = undefined;
                this._selGridContainer.remove();
                this._selGridContainer = undefined;
                this._addButton = undefined;
                this._removeButton = undefined;
                this._selectedTargetsGrid = undefined;
                this._convertButton = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _initTargets(ids = []) {
        this._addToTargets(ids, true);
        ids.forEach((id) => {
            this._targets[id] = true;
        });
    }

    _addToTargets(ids, skipModelUpdate) {
        let filteredNodeIds = [],
            isConstruct = false,
            nodeIdsToAdd = [];
        if (
            _.get(
                this._model._workTriggerDetailsView._triggerType.getWorkTarget(),
                "category",
                ""
            ) === "construct"
        ) {
            const entities = this._model._availableDevicesPagingFeed.getEntitiesById(ids);
            entities.forEach((item) => {
                isConstruct = true;
                nodeIdsToAdd = _.get(
                    this._model._workTriggerDetailsView._triggerType.getWorkTarget(),
                    "ids",
                    []
                );
                if (_.isEmpty(item.getNodeId())) {
                    const idx = ids.indexOf(item.getId());
                    ids.splice(idx, 1);
                } else {
                    nodeIdsToAdd.push(item.getNodeId());
                    filteredNodeIds.push(item.getNodeId());
                }
            });
        }

        this._model.availableTargetsPagingFeed.addIds(ids);

        if (isConstruct) {
            this._model.selectedTargetsPagingFeed.addIds(ids, nodeIdsToAdd);
        } else {
            this._model.selectedTargetsPagingFeed.addIds(ids);
        }

        this._selectedTargetsGrid.setSelectedRows(ids);
        this._availableTargetsGrid.setSelectedRows(null);

        // this._model.selectedTargetsPagingFeed.reestablish();

        this._addButton.disabled = true;
        this._removeButton.disabled = this._checkDisabled(false);
        this._removeAllButton.disabled = this._checkDisabled(false);

        if (!skipModelUpdate) {
            this._addIdsToModel(isConstruct ? filteredNodeIds : ids);
        }
    }

    _addIdsToModel(ids) {
        ids.forEach((id) => {
            this._targets[id] = true;
        });
        this._model._setWorkTarget(Object.keys(this._targets));
    }

    _removeFromTargets(ids) {
        let filteredNodeIds = [],
            isConstruct = false,
            nodeIdsToRemove = [];

        if (
            _.get(
                this._model._workTriggerDetailsView._triggerType.getWorkTarget(),
                "category",
                ""
            ) === "construct"
        ) {
            const entities = this._model._availableDevicesPagingFeed.getEntitiesById(ids);
            entities.forEach((item) => {
                isConstruct = true;
                nodeIdsToRemove = _.get(
                    this._model._workTriggerDetailsView._triggerType.getWorkTarget(),
                    "ids",
                    []
                );
                const indexToRemove = nodeIdsToRemove.indexOf(item.getNodeId());
                nodeIdsToRemove.splice(indexToRemove, 1);
                filteredNodeIds.push(item.getNodeId());
            });
        }

        this._model.availableTargetsPagingFeed.removeIds(ids);

        if (isConstruct) {
            this._model.selectedTargetsPagingFeed.removeIds(ids, nodeIdsToRemove);
        } else {
            this._model.selectedTargetsPagingFeed.removeIds(ids);
        }

        this._availableTargetsGrid.setSelectedRows(ids);
        this._selectedTargetsGrid.setSelectedRows(null);

        this._selectedTargetsGrid.refreshView();

        this._addButton.disabled = this._checkDisabled(false);
        this._removeButton.disabled = true;
        this._removeAllButton.disabled = this._checkDisabled(
            _.isEmpty(this._selectedTargetsGrid.getEntities())
        );

        this._removeIdsFromModel(isConstruct ? filteredNodeIds : ids);
    }

    _removeIdsFromModel(ids) {
        ids.forEach((id) => {
            delete this._targets[id];
        });
        this._model._setWorkTarget(Object.keys(this._targets));
    }

    _checkDisabled(isDisabled) {
        return !!this._model.workTriggerDetailsView.disabled || !!isDisabled;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = WorkTriggerTargetsTabRenderer;
